module.exports = __webpack_public_path__ + "static/media/card-ads-es.3143f8d6.png";